import { getDeleteAccess, getSelectedCompany, getUserDetails } from "./auth";

export const canUserDelete = () => {
  const deleteAccess = getDeleteAccess();

  // If delete access array is missing or empty → return false
  if (
    !deleteAccess ||
    !Array.isArray(deleteAccess) ||
    deleteAccess.length === 0
  ) {
    return false;
  }

  const deleteControl = deleteAccess[0];

  const userDetails = getUserDetails();
  const isAdmin = userDetails?.role === "admin"; // <-- IMPORTANT FIX
  const isOtherUser = userDetails?.role === "other_user"; // <-- IMPORTANT FIX

  const selectedCompanyId = getSelectedCompany()?.id;

  return (
    isAdmin ||
    isOtherUser ||
    (!isAdmin &&
      deleteControl?.delete_access === true &&
      Array.isArray(deleteControl?.company_id) &&
      deleteControl.company_id.includes(selectedCompanyId))
  );
};
